const DIRECTORY = {

    '01 SAT': {
        '01 SAT Real': {
            'Full TEST': null,
            'Reading Only': null,
            'Writing Only': null,
            'Math Only': null,
            'SAT AK': null
        },
        '02 SAT Practice': {
            'TEST': null,
            'SAT AK': null
        },
        '03 SAT Real Solution': {
            'Full Solution': null,
            'Reading Only': null,
            'Writing Only': null,
            'Math Only': null
        },
    },
    '02 ACT': {
        '01 ACT Real': {
            'Full TEST': null,
            'English Only': null,
            'Math Only': null,
            'Reading Only': null,
            'Science Only': null,
            'ACT AK': null,
        },
        '02 ACT Practice': {
            'Full TEST': null,
            'English Only': null,
            'Math Only': null,
            'Reading Only': null,
            'Science Only': null,
            'ACT AK': null,
        },
        '03 ACT Real Solution': {
            'Full Solution': null,
            'English Only': null,
            'Math Only': null,
            'Reading Only': null,
            'Science Only': null
        },
        '04 ACT Essay': null,
    },
    '03 PSAT': {
        '01 PSAT Real': null,
        '02 PSAT AK': null,
    },
    '04 AP': {
        '01 AP Physics 1': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '02 AP ComScience': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '03 AP Cal AB': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '04 AP Cal BC': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '05 AP Stat.': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '06 AP Bio': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '07 AP US History': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '08 AP Chem': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '09 AP World History': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '10 AP Art History': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '11 AP Comparative Government and Politics': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '12 AP Environmental Science': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '13 AP European History': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '14 AP Human Geography': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '15 AP Language': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '16 AP Literature and Composition': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '17 AP Macroeconomics': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '18 AP Microeconomics': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '19 AP Physics 2': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '20 AP Physics B': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '21 AP Physics C - Electricity and Magnetism': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '22 AP Physics C - Mechanics': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '23 AP Spanish Language': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '24 AP US Government and Politics': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '25 AP Psychology': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
        '26 AP Precal': {
            'Real Test': null,
            'Practice Test': null,
            'AK': null
        },
    },
    '05 High School Test Prep': {
        '01 SSAT': {
            'Upper': {
                'TEST': null,
                'AK': null,
            },
            'Middle': {
                'TEST': null,
                'AK': null,
            },
        },
        '02 ISEE': {
            'Upper': {
                'TEST': null,
                'AK': null,
            },
            'Middle': {
                'TEST': null,
                'AK': null,
            },
            'Lower': {
                'TEST': null,
                'AK': null,
            },
        },
        '03 BCA Prep': {
            'TEST': null,
            'BCA Prep AK': null, 
        },
        '04 HSPT': {
            'TEST': null,
            'AK': null,
        },
    },
    '06 NY Regent Test': {
        '01 Prealgebra': {
            'Full Test': null,
            'Model Response': null,
            'AK': null,
            'Textbook': null,
        },
        '02 Algebra 1': {
            'Full Test': null,
            'Model Response': null,
            'AK': null,
            'Textbook': null,
        },
        '03 Geometry': {
            'Full Test': null,
            'Model Response': null,
            'AK': null,
            'Textbook': null,
        },
        '04 Algebra 2': {
            'Full Test': null,
            'Model Response': null,
            'AK': null,
            'Textbook': null,
        },
    },
    '08 Prestige Books': {
        '01 ACT': null, 
        '02 SAT': null,
    }, 
    '09 Program': null,
    'SHP': null,
}

export { DIRECTORY };
